
import { defineComponent } from "vue";
import { AlertNotification } from "@/types/notificationAlert.type";
import { Filter } from "@/types/filter.type";
import { deleteNotification, getNotifications } from "@/service/generatedAlert.service";
import AlertImageComponent from "@/components/alerts/AlertImage.component.vue";
import { Action, ElMessage, ElMessageBox } from "element-plus";
import { changeAlertActive } from "@/service/alert.service";
import { getEstimationsByImageParameter } from "@/service/estimation.service";
import { getSamplingPointById } from "@/service/samplingpoint.service";
import { getTmoa } from "@/service/tmoa.service";

export default defineComponent({
  emits: ["update-selected-items", "update-query", "search-notifications"],
  components: {
    AlertImageComponent,
  },
  props: {
    typeAlert: {
      type: String,
      required: true,
    },
    alertId: {
      type: Number,
    },
    detailRouterName: {
      type: String,
    },
    query: {
      type: String,
    },
    queryHistory: {
      type: Number,
    },
    queryParams: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: Object as () => any[],
    },
    querySamPoint: {
      type: Number,
    },
    list: {
      type: Object as () => AlertNotification[],
    },
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
    //aaa
    selectedAll: {
      type: Boolean,
    },
  },
  data() {
    return {
      hasData: true,
      alerts: [] as AlertNotification[],
      showAlertForm: false,
      currentPage: 1 as number,
      rowPerPage: 10 as number,
      totalRows: 0 as number,
      tipoSampling: "default" as string,
      tipoStation: "primary" as string,
      ruleDisplayOrOpened: false as boolean,
      selectedItems: [] as AlertNotification[],

      alertTextMap: {} as Record<number, string>,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      parametersAlerts: [] as any[],
      // estimation: [] as Estimation[],
      alertEstimations: {} as Record<number, string>,
    };
  },
  async mounted() {
    const id = this.$route.query.id as unknown as number;

    if (id) {
      this.$emit("search-notifications", id);
      this.refreshAlert(this.typeAlert);
    } else {
      this.refreshAlert(this.typeAlert);
    }
  },
  methods: {
    //Activar / desactivar alerta de la notificación
    deactivateAlert(item: AlertNotification) {
      if (item.id && item.alert?.active !== undefined) {
        const typeMessage = item.alert?.active ? "activateAlert" : "deactivateAlert";
        ElMessageBox.confirm(
          this.$t("confirm." + typeMessage, { name: item.alert.name }),
          this.$t("label.warning"),
          {
            confirmButtonText: this.$t("btn.accept"),
            cancelButtonText: this.$t("btn.cancel"),
            type: "warning",
            dangerouslyUseHTMLString: true,
            callback: (action: Action) => {
              if (
                action === "confirm" &&
                item.alert &&
                item.alert.id &&
                item.alert?.active !== undefined
              ) {
                changeAlertActive(item.alert.id, item.alert?.active).then(() => {
                  ElMessage.success(this.$t("success.action"));
                  this.currentPage = 1;
                  this.refreshAlert();
                });
              } else {
                if (item.alert) {
                  item.alert.active = !item.alert?.active;
                  this.currentPage = 1;
                  this.refreshAlert();
                }
              }
            },
          }
        );
      }
    },
    // Seleccionar/desmarcar las notificaciones de la pagina
    selectAllItems(selectedAll: boolean) {
      if (selectedAll) {
        // this.selectedItems = [...this.alerts];
        // Añadir elementos no duplicados
        this.selectedItems = [
          ...this.selectedItems,
          ...this.alerts.filter((alert) => !this.selectedItems.includes(alert)),
        ];
      } else {
        this.selectedItems = [];
      }
      this.$emit("update-selected-items", this.selectedItems);
    },
    // Historico de {id} alerta
    viewHistory(id: number | undefined): void {
      if (!id) return;
      this.$emit("update-query", id);
    },
    isSelected(id: number | undefined): boolean {
      if (!id) return false;
      return this.selectedItems.some((item) => item.id === id);
    },
    handleCheckboxChange(item: AlertNotification): void {
      if (!item || !item.id) return;

      const isAlreadySelected = this.selectedItems.some((i) => i.id === item.id);

      if (isAlreadySelected) {
        this.selectedItems = this.selectedItems.filter((i) => i.id !== item.id);
      } else {
        this.selectedItems.push(item);
      }
      this.$emit("update-selected-items", this.selectedItems);
    },

    async refreshAlert(
      typeAlert?: string,
      startDate?: Date | string,
      endDate?: Date | string,
      item?: AlertNotification
    ) {
      let index = -1;
      if (this.alerts && item) {
        index = this.alerts.findIndex((i) => i.id === item.id);
      }
      if (index !== -1 && item) {
        this.alerts[index] = item;
      } else {
        const filter: Filter = {};
        if (this.query) {
          filter.multi = this.query;
        }
        if (startDate !== undefined && endDate !== undefined) {
          this.currentPage = 1;
          filter.fields = {
            "alertNotification.dateTime": {
              operator: "between",
              value: [startDate, endDate],
            },
          };
        }
        if (this.queryHistory) {
          filter.fields = {
            "alertNotification.alertId": {
              operator: "equal",
              value: this.queryHistory,
            },
          };
        }

        if (this.startDate !== undefined && this.endDate !== undefined) {
          filter.fields = {
            "alertNotification.dateTime": {
              operator: "between",
              value: [this.startDate, this.endDate],
            },
          };
        }

        const pagination = await getNotifications(
          this.currentPage,
          this.rowPerPage,
          typeAlert,
          filter,
          this.querySamPoint,
          this.queryParams
        );

        this.alerts = pagination.data;

        this.totalRows = pagination.totalRows;

        this.alerts.forEach((alert) => this.getAlertEstimation(alert));
      }
      if (this.alerts.length <= 0) {
        this.hasData = false;
        return;
      } else {
        this.hasData = true;
      }

      return this.alerts;
    },

    changePaginationSize(size: number): void {
      this.rowPerPage = size;
      this.refreshAlert(this.typeAlert);
    },
    changePaginationPage(page: number): void {
      this.currentPage = page;
      this.refreshAlert(this.typeAlert).then(() => {
        if (this.selectedAll) {
          this.selectedItems = [
            ...this.selectedItems,
            ...this.alerts.filter(
              (alert) => !this.selectedItems.some((item) => item.id === alert.id)
            ),
          ];
          this.$emit("update-selected-items", this.selectedItems);
        }
      });
    },

    getDate(date: Date) {
      return new Date(date).toLocaleString("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getCondition(item: any[]) {
      let conditionString = "";

      item.forEach((data, index) => {
        let conditionPart = `${data.parameter.name} ${data.operator} ${data.value}`;

        if (index < item.length - 1) {
          if (data.compositeOperator === "AND") {
            conditionPart += " Y ";
          } else if (data.compositeOperator === "OR") {
            conditionPart += " OR ";
          }
        }
        conditionString += conditionPart;
      });

      return conditionString;
    },

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getData(item: any) {
      return item.alert?.id;
    },

    ruleDisplayBeforeTag(compositeOperator?: string) {
      if (compositeOperator === "OR" && !this.ruleDisplayOrOpened) {
        this.ruleDisplayOrOpened = true;
        return "(";
      } else {
        return "";
      }
    },

    ruleDisplayAfterTag(compositeOperator?: string) {
      let after = "";
      if (
        (compositeOperator === "AND" || compositeOperator === undefined) &&
        this.ruleDisplayOrOpened
      ) {
        after += ")";
        this.ruleDisplayOrOpened = false;
      }
      if (compositeOperator === "AND") {
        after += " Y ";
      } else if (compositeOperator === "OR") {
        after += " O ";
      }
      return after;
    },

    async deleteAlert(item: AlertNotification | undefined = undefined) {
      if (item && item.id) {
        ElMessageBox.confirm(this.$t("confirm.deleteGeneratedAlert"), this.$t("label.warning"), {
          confirmButtonText: this.$t("btn.accept"),
          cancelButtonText: this.$t("btn.cancel"),
          type: "warning",
          dangerouslyUseHTMLString: true,
          callback: (action: Action) => {
            if (action === "confirm") {
              deleteNotification(item).then(() => {
                ElMessage.success(this.$t("success.action"));
                this.refreshAlert(this.typeAlert);
              });
            }
          },
        });
      }
    },

    async getAlertEstimation(item: AlertNotification) {
      if ((!item.image?.fileName || !item.alert?.parameterAlerts) && item.id) {
        this.alertEstimations[item.id] = "";
        return;
      }

      if (item.alert && item.alert.parameterAlerts && item.image && item.id) {
        let paramIds: number[] = item.alert.parameterAlerts
          .map((data) => data.parameter?.id)
          .filter((id): id is number => id !== undefined);

        try {
          if (item.image.samplingPoint?.id) {
            let tmoaList: any[] = [];

            const firstAlert = item.alert.parameterAlerts[0];
            const isFirstTmoa = firstAlert?.parameter?.code === "TMOA";

            if (isFirstTmoa) {
              const sp = await getSamplingPointById(item.image.samplingPoint.id);

              const filter: Filter = {
                fields: {
                  "tmoa.samplingPointId": { operator: "equal", value: sp.id },
                },
              };

              tmoaList = await getTmoa(filter);
            }

            const estimations = await getEstimationsByImageParameter(item.image.id, paramIds);

            if (
              isFirstTmoa &&
              estimations.length &&
              estimations[0].value !== undefined &&
              tmoaList.length
            ) {
              const match = tmoaList.find((t) => t.value === estimations[0].value);
              if (match) {
                this.alertEstimations[item.id] = match.name || "-";
                return;
              }
            }
            this.alertEstimations[item.id] =
              estimations.length && estimations[0].value !== undefined
                ? `${estimations[0].value} ${estimations[0].parameter?.unit || ""}`
                : "-";
          }
        } catch (error) {
          console.error("Error getting alert estimation:", error);
          this.alertEstimations[item.id] = "Error";
        }
      }
    },
  },
  watch: {
    query: {
      handler() {
        this.parametersAlerts = [];
        this.refreshAlert(this.typeAlert);
      },
      deep: false,
    },
    queryHistory: {
      handler() {
        this.refreshAlert(this.typeAlert);
      },
      deep: false,
    },
    queryParams: {
      handler() {
        this.parametersAlerts = [];
        this.refreshAlert(this.typeAlert);
      },
      deep: false,
    },
    querySamPoint: {
      handler() {
        this.parametersAlerts = [];
        this.refreshAlert(this.typeAlert);
      },
      deep: false,
    },
    startDate: {
      handler() {
        this.refreshAlert(this.typeAlert);
      },
      deep: false,
    },
    endDate: {
      handler() {
        this.refreshAlert(this.typeAlert);
      },
      deep: false,
    },
  },
});
